<script>
    // import {state, loader_i, loader_max} from "../stores/contracts";
    // import {state_infura} from "../stores/contracts-infura";
    // import Transactions from "../components/Transactions.svelte";
    // import Navigation from "../components/Navigation.svelte";

    import {Route, navigateTo} from 'svelte-router-spa';
    // import Navigation from "../components/Navigation.svelte";


    // import {onMineConfirmed} from "../stores/contract";
    // import TokenAlert from "../components/TokenAlert.svelte";

    export let currentRoute
    const params = {}
</script>

<style>
    /*.main{*/
    /*    max-width: 700px;*/
    /*    color:white;*/

    /*    padding-top: 50px;*/

    /*}*/

    /*@media (max-width: 750px) {*/
    /*    .main{*/

    /*    }*/

    /*}*/

    .main{
        width:100vw;
        height:100vh;

        background-image: url("/images/Vaporwave_Background.png");
        background-size: cover;

        /*background: ;*/
    }
</style>




<!--<div>-->
<!--    <Navigation />-->

    <div class="main">
<!--        State: {$state} <br/>-->
<!--        Infura: {$state_infura} <br/>-->
<!--        {#if $state === "loading"}-->
<!--            | ({Math.round(100 * $loader_i/$loader_max)}%)-->
<!--        {/if}-->
        <Route {currentRoute}  {params} />
    </div>

<!--</div>-->